import { createContext } from "react";

import {
  AppConfiguration,
  GenerationMode,
  Globals,
  ParentUrlCallback,
} from "./types";

export const appSettingsStorage: {
  serviceBaseUrl: string;
  baseOrigin: string;
} = {
  serviceBaseUrl: "",
  baseOrigin: "",
};

export const ConfigContext = createContext<AppConfiguration | null>(null);

export const defaultParentWindowSize = {
  innerWidth: 500,
  innerHeight: 700,
};

export const GlobalsContext = createContext<Globals | null>(null);

export const generationModes: Record<
  NonNullable<GenerationMode>,
  GenerationMode
> = {
  submitting: "submitting",
  generating: "generating",
};

export const parentUrlsCallbacks: ParentUrlCallback[] = [];
